import React, { ReactNode } from "react";
import Linkify from "react-linkify";

interface AutolinkProps {
  children: ReactNode;
}
export const Autolink: React.FC<AutolinkProps> = ({ children }) => (
  <Linkify componentDecorator={linkDecorator}>{children}</Linkify>
);

const linkDecorator = (href: string, text: string, key: any) => (
  <a href={href} key={key} target="_blank" rel="noopener noreferrer">
    {text}
  </a>
);
